import React from 'react'
import { WidgetCard } from '../style'
import { MilchpreisContainer, MilchpreisLeft } from '../widgets/MilkPriceWidget/style'
import { SkeletonLine, SkeletonBox } from './skeleton.style'

const MilkPriceWidgetSkeleton: React.FC = () => (
  <WidgetCard>
    <SkeletonLine width='150px' height='18px' style={{ marginBottom: '20px' }} />
    <MilchpreisContainer>
      <MilchpreisLeft>
        <SkeletonLine width='110px' height='36px' style={{ marginBottom: '15px' }} />
        {[...Array(5)].map((_, i) => (
          <div key={i} style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
            <SkeletonLine width='55px' height='13px' style={{ marginBottom: 0 }} />
            <SkeletonLine width='130px' height='13px' style={{ marginBottom: 0 }} />
          </div>
        ))}
      </MilchpreisLeft>
      <SkeletonBox height='250px' />
    </MilchpreisContainer>
  </WidgetCard>
)

export default MilkPriceWidgetSkeleton
